<template>
    <div>
        <div v-if="loading" class="loading"></div>
        <div v-if="errors" v-for="error in errors">
            <div class="div" v-if="Array.isArray(error)">
                <div class="alert alert-danger" role="alert" v-for="er in error">{{ er }}</div>
            </div>
            <div class="alert alert-danger" role="alert" v-else>{{ error }}</div>

        </div>

        <b-form @submit="onSubmit">
            <b-form-group
                id="select-category"
                label="Категория"
                label-for="category"
            >
                <b-form-select v-model="item.category_id">
                    <b-form-select-option id="category" :key="index" :value="category.v1c_id" v-for="(category, index) in categories" >{{ category.name }}</b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-form-group
                id="select-type"
                label="Тип транспортировки"
                label-for="type"
            >
                <b-form-select v-model="item.type">
                    <b-form-select-option id="type" :value="type" :key="index" v-for="(type, index) in types">{{ type }}</b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-form-group
                    id="input-name"
                    label="Наименование (string)"
                    label-for="name"
                    description=""
            >
                <b-form-input
                        id="name"
                        v-model="item.name"
                        type="text"
                        placeholder="Name"
                ></b-form-input>
            </b-form-group>


            <b-form-group
                    id="vendor-code"
                    label="Код (integer)"
                    label-for="vendor_code"
                    description=""
            >
                <b-form-input
                        id="vendor_code"
                        v-model="item.vendor_code"
                        type="text"
                        placeholder="vendor_code"
                ></b-form-input>
            </b-form-group>


            <b-form-group
                    id="input-full-name"
                    label="Полное наименование (string)"
                    label-for="fullname"
                    description=""
            >
                <b-form-input
                        id="fullname"
                        v-model="item.full_name"
                        type="text"
                        placeholder="FullName"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="count"
                    label="Количество (integer)"
                    label-for="count"
                    description=""
            >
                <b-form-input
                        id="count"
                        v-model="item.count"
                        type="text"
                        placeholder="Count"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="price-dealer"
                    label="Цена (дилер) (integer)"
                    label-for="price_dealer"
                    description=""
            >
                <b-form-input
                        id="price_dealer"
                        v-model="item.price_dealer"
                        type="text"
                        placeholder="PriceDealer"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="price-wholesale"
                    label="Цена (оптовик) (integer)"
                    label-for="price_wholesale"
                    description=""
            >
                <b-form-input
                        id="price_wholesale"
                        v-model="item.price_wholesale"
                        type="text"
                        placeholder="PriceWholeSale"
                ></b-form-input>
            </b-form-group>

            <b-form-group
                    id="filter-label"
                    label="Фильтр (string)"
                    label-for="filter"
                    description=""
            >
                <b-form-input
                        id="filter"
                        v-model="item.filter"
                        type="text"
                        placeholder="filter"
                ></b-form-input>
            </b-form-group>


            <b-form-group
                id="textarea-label"
                label="Описание (string)"
                label-for="desc"
            >
                <b-form-textarea
                    id="desc"
                    v-model="item.desc"
                    placeholder="Enter something..."
                    rows="5"
                ></b-form-textarea>
            </b-form-group>


            <b-form-group 
                label="Дата доставки (неделя) (integer)"
                id="date"
                label-for="date"
                description=""
            >
                <!-- <b-datepicker
                    v-model="item.date"
                    placeholder="Click to select..."
                    icon="calendar-today"
                    trap-focus>
                </b-datepicker> -->
                <b-form-input
                    id="date"
                    v-model="week"
                    type="text"
                    placeholder="Week"
                ></b-form-input>
            </b-form-group>

            <b-form-group label="Превью">
                <p v-if="item.image">
                    <img :src="axios.defaults.baseImageURL + 'uploads/' + item.image" class="image-cart" alt="">
                </p>
                <input type="file" id="image" ref="image" @change="handleFileUpload()"/>
            </b-form-group>
            
            <b-form-group label="Внутренние изображения">
                <p v-if="item.images">
                    <img :src="axios.defaults.baseImageURL + 'uploads/' + img" :key="index" v-for="(img, index) in JSON.parse(item.images) " class="image-cart multiple-image" alt="">
                </p>
                <input type="file" id="images" ref="images" multiple @change="handleFilesUpload($event)"/>
            </b-form-group>

            <div v-if="errors" v-for="error in errors">
                <div class="div" v-if="Array.isArray(error)">
                    <div class="alert alert-danger" role="alert" v-for="er in error">{{ er }}</div>
                </div>
                <div class="alert alert-danger" role="alert" v-else>{{ error }}</div>

            </div>
            
            <div class="buttons">
                <b-button type="submit" :disabled="disabled">Update</b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
Date.prototype.getWeek = function (dowOffset) {
/*getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.meanfreepath.com */

    dowOffset = typeof(dowOffset) == 'number' ? dowOffset : 0; //default dowOffset to zero
    var newYear = new Date(this.getFullYear(),0,1);
    var day = newYear.getDay() - dowOffset; //the day of week the year begins on
    day = (day >= 0 ? day : day + 7);
    var daynum = Math.floor((this.getTime() - newYear.getTime() - 
    (this.getTimezoneOffset()-newYear.getTimezoneOffset())*60000)/86400000) + 1;
    var weeknum;
    //if the year starts before the middle of a week
    if(day < 4) {
        weeknum = Math.floor((daynum+day-1)/7) + 1;
        if(weeknum > 52) {
            nYear = new Date(this.getFullYear() + 1,0,1);
            nday = nYear.getDay() - dowOffset;
            nday = nday >= 0 ? nday : nday + 7;
            /*if the next year starts before the middle of
              the week, it is week #1 of that year*/
            weeknum = nday < 4 ? 1 : 53;
        }
    }
    else {
        weeknum = Math.floor((daynum+day-1)/7);
    }
    return weeknum;
};

    export default {
        data() {
            return {
                item: {},
                categories: [],
                image: null,
                images: [],
                week: null,
                errors: [],
                disabled: false,
                loading: false,
                types: ['Самолёт', 'ЖД', 'Фура'],
            }
        },

        mounted() {
            if (this.$route.params.id) {
                this.loading = true
                this.axios
                    .get(this.axios.defaults.baseURL + 'admin/ways/' + this.$route.params.id)
                    .then(response => {
                        this.item = response.data.product

                        let date = new Date(response.data.product.date);
                        this.week = date.getWeek();

                        console.log(this.item);
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                    this.loading = false
                })
            }

            this.axios
                .get(this.axios.defaults.baseURL + 'admin/categories')
                .then(response => {
                    this.categories = response.data.categories;
                })
                .catch(error => {
                    console.log(error);
                }).finally(() => {
                this.loading = false
            })
        },

        methods: {

            isNumeric: function (n) {
                return !isNaN(parseFloat(n)) && isFinite(n);
            },

            getDateOfWeek : function(w, y) {
                var simple = new Date(y, 0, 1 + (w - 1) * 7);
                var dow = simple.getDay();
                var ISOweekStart = simple;
                if (dow <= 4)
                    ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
                else
                    ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
                return ISOweekStart;
            },

            checkForm:function(e) {
                e.preventDefault();
                this.errors = [];
                if(!this.item.name) this.errors.push("Наименование обязательно.");
                if(!this.item.price_dealer) this.errors.push("Цена обязательна.");
                if(!this.item.category_id) this.errors.push("Категория обязательна.");
                if(!this.week) this.errors.push('Неделя доставки обязательна')
                if(this.isNumeric(this.item.vendor_code) === false) this.errors.push("Код должен быть в цифрах")
                if(this.isNumeric(this.item.price_dealer) === false) this.errors.push("Цена для дилера должна быть в цифрах")
                if(this.isNumeric(this.item.price_wholesale) === false) this.errors.push("Цена для оптовика должна быть в цифрах")
                if(this.isNumeric(this.item.count) === false) this.errors.push("Количество должно быть в цифрах")
                if(this.isNumeric(this.week) === false) this.errors.push("Неделя должна быть в цифрах")
            },

            onSubmit(e){
                this.disabled = true;
                this.checkForm(e)
                this.item.week = this.week;
                this.item.date = this.getDateOfWeek(this.week, new Date().getFullYear())
                console.log(this.item.date);
                e.preventDefault()
                let formData = new FormData();
                formData.append('item', JSON.stringify(this.item));
                formData.append('image', this.image);
                for(let i = 0; i<this.images.length; i++) {
                    formData.append('image'+i, this.images[i])
                }
                formData.append('images', this.images);

                let idx

                if(typeof this.$route.params.id === 'undefined') {
                    idx = '';
                    formData.append('_method', 'POST');
                } else {
                    idx = '/' + this.$route.params.id;
                    formData.append('_method', 'PUT');    
                }

                if (this.errors.length === 0){
                    this.axios
                        .post(this.axios.defaults.baseURL + 'admin/ways' + idx, formData)
                        .then(response => {
                            if (response.data.message === 'success') {
                                this.$router.push({name: 'ProductsOnWay', params: {message: 'Товар успешно обновлен'}})
                            }else {
                                this.errors = response.data.errors
                            }
                            this.disabled = false;
                        })
                        .catch(error => {
                            console.log(error);
                        })
                }
            },

            handleFileUpload() {
                this.image = this.$refs.image.files[0];
            },

            handleFilesUpload(e) {
                for(let i = 0; i<e.target.files.length; i++) {
                    this.images.push(e.target.files[i]);
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    .image-cart {
        width: 100%;
        height: 200px;
        object-fit: contain;
        object-position: left;
    }

    .multiple-image {
        width: auto;
        max-width: 350px;
        margin-right: 15px;
    }

    .buttons {
        margin: 25px 0;
    }

    .b-time-header {
        background-color: #fff;
        position: relative;
        width: auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/app/admin/way/edit.vue